// @flow
import React from 'react';
import bem from '@justpark/helpers/src/bem/bem';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import LinkButton from '@justpark/ui/src/components/LinkButton';
import LegacyLink from '../Common/LegacyLink';
import { selectIsAppFeatureLimited } from '../../stores/partner';
import { logout } from '../../stores/auth';

const SideNavigation = () => {
  const isSpaceOwner = useSelector((state) => state.auth?.user?.isSpaceOwner);
  const hasSeasonTickets = useSelector(
    (state) => state.auth?.user?.hasSeasonTicket
  );
  const isAppFeatureLimited = useSelector(selectIsAppFeatureLimited);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const baseClass = 'c-sideNavigation';

  return (
    <ul className={baseClass}>
      <li className={`${baseClass}__item`}>
        <NavLink
          className={({ isActive }) => bem(baseClass, 'link', { isActive })}
          to="/dashboard/bookings/made"
        >
          {t('navigation:bookingsMade', 'Bookings made')}
        </NavLink>
      </li>

      {isSpaceOwner && !isAppFeatureLimited && (
        <li className={`${baseClass}__item`}>
          <NavLink
            className={({ isActive }) => bem(baseClass, 'link', { isActive })}
            to="/dashboard/bookings/received"
          >
            {t('navigation:bookingsReceived', 'Bookings received')}
          </NavLink>
        </li>
      )}

      {hasSeasonTickets && !isAppFeatureLimited && (
        <li className={`${baseClass}__item`}>
          <NavLink
            className={({ isActive }) => bem(baseClass, 'link', { isActive })}
            to="/dashboard/season-tickets"
          >
            {t('navigation:seasonTickets', 'Tickets & permits')}
          </NavLink>
        </li>
      )}

      {!isAppFeatureLimited && (
        <li className={`${baseClass}__item`}>
          <LegacyLink to="dashboard/messaging">
            {t('navigation:messages', 'Messages')}
          </LegacyLink>
        </li>
      )}

      {isSpaceOwner && !isAppFeatureLimited && (
        <li className={`${baseClass}__item`}>
          <NavLink
            className={({ isActive }) => bem(baseClass, 'link', { isActive })}
            to="/dashboard/parking-spaces"
            isActive={(_, { pathname }) =>
              pathname.includes('/dashboard/listings/edit/') ||
              pathname.includes('/dashboard/parking-spaces/')
            }
          >
            {t('navigation:parkingSpaces', 'Manage my spaces')}
          </NavLink>
        </li>
      )}

      {!isAppFeatureLimited && (
        <li className={`${baseClass}__item`}>
          <LegacyLink to="dashboard/billing/">
            {t('navigation:billing', 'Billing & withdrawals')}
          </LegacyLink>
        </li>
      )}

      <li className={`${baseClass}__item`}>
        <NavLink
          className={({ isActive }) => bem(baseClass, 'link', { isActive })}
          to="/dashboard/profile"
        >
          {t('navigation:profile', 'My profile')}
        </NavLink>
      </li>

      <li className={`${baseClass}__item`}>
        <LinkButton
          className={bem(baseClass, 'link')}
          type="button"
          onClick={() => {
            dispatch(logout());
          }}
        >
          {t('cta:logOut', 'Log out')}
        </LinkButton>
      </li>
    </ul>
  );
};

export default SideNavigation;
